import { MainAssortmentsEdit } from '@features/TimberBuyer/SalesAgreements/MainAssortments/MainAssortmentsEdit'
import { createFileRoute } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate'

const EditMainAssortmentsRoute: React.FC = () => {
  const { timberBuyerId } = Route.useParams()

  return <MainAssortmentsEdit timberBuyerId={timberBuyerId} />
}

export const Route = createFileRoute(
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/main-assortments/',
)({
  component: EditMainAssortmentsRoute,
  staticData: {
    breadcrumb: t('timberbuyer-salesagreements-mainassortments.breadcrumb'),
  },
})
